<nav class="navbar navbar-expand-md navbar-light main-menu d-none d-md-block" style="box-shadow:none">
  <div class="container">

    <a class="navbar-brand" [appHref]="'/'">
      <img alt="Logo Stem" src="assets/img/Logo-stem-france-blu.webp" class="logo-desktop">
    </a>

    <ul class="navbar-nav ml-auto d-block d-md-none no-print">
      <li class="nav-item">
        <a class="cart-icon btn" [appHref]="'/carrello'"><i class="fas fa-shopping-cart icon-single"></i> <span class="badge badge-danger">{{totaleCarrello}}</span></a>
      </li>
    </ul>

    <div class="collapse navbar-collapse no-print">

      <div class="form-newsletter form-inline form-menu my-2 my-lg-0 ml-auto">
        <div class="input-group">
          <input type="text" class="form-control" (keydown.enter)="cerca()" placeholder="{{'CERCA' | translate | htmlToText}}" name="ricerca" [(ngModel)]="termineRicerca">
          <div class="input-group-append">
            <button title="{{'CERCA' | translate | htmlToText}}" class="btn btn-stem" type="button" (click)="cerca()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      <ul class="navbar-nav no-print">
        <li class="nav-item">
          <a class="cart-icon btn" [appHref]="'/carrello'"><i class="fas fa-shopping-cart icon-single"></i> <span class="badge badge-danger">{{totaleCarrello}}</span></a>
        </li>
      </ul>
    </div>

  </div>
</nav>
